<template>
  <div class="big-box">
    <div class="container">
      <div class="pro-box" v-if="proInfo.id">
        <!-- <div class="title">{{$t('DK.productDetails')}}</div> -->
        <div class="detail-box">
          <div class="img-info">
            <div class="goods-img">
              <pic-zoom :bigSrc="activeImg || proInfo.imgUrl" v-if="proInfo.imgUrl"></pic-zoom>
            </div>
            <div class="swiper">
              <swiper :options="swiperOption" ref="mySwiper" class="swiper-box">
                <swiper-slide class="swiper-slide" v-for="(item, index) in proInfo.imgList" :key="index">
                  <div class="item-img">
                    <img :src="item.filePath" @click.stop="hoverImg(item)" @mouseenter="setImg(item)" class="swiper-img" />
                  </div>
                </swiper-slide>
              </swiper>
              <!-- 左右箭头 -->
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
          <div class="pro-info">
            <div class="right-title">{{ $hs(proInfo.pr_Na,proInfo.pr_En_Na,proInfo.basicThreeLanguage) }}</div>
            <div class="label_No">
              <span>{{$hs('产品编号','Item NO.','Producto no.')}}：</span>
              <span style="color: #222222;">{{ proInfo.co_Nu }}</span>
            </div>

            <div class="label_prc">
              <span>{{$hs('产品价格','Price','Precio del producto')}}：</span>
              <span v-if="userInfo.status === 1" style="color: red;">
                <span>{{ userInfo.symbol }}{{Number(proInfo.price)}}</span>
              </span>
              <span
                v-else
                style="color: #FF0000;font-size: 20px;cursor: pointer;"
                @click="login"
              >{{ $hs('请登录','Please Login','Por favor inicie sesión') }}</span>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$hs('包装方式','Packing','Forma de embalaje')}}：</span>
                <span class="label_content">{{ $hs(proInfo.ch_Pa,proInfo.en_Pa,proInfo.packThreeLanguage) }}</span>
              </div>

              <div class="label_items">
                <span class="label">{{$hs('外箱装量','Quantity:','Cantidad de carga en cartón externo')}}：</span>
                <span class="label_content">{{ proInfo.ou_Lo || 0 }}(PCS)</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$hs('内盒个数','Inner Boxes','Número de cajas internas')}}：</span>
                <span class="label_content">{{ proInfo.in_En || 0 }}</span>
              </div>
              <div class="label_items">
                <span class="label">{{$hs('产品规格','Product Size','Especificaciones del producto')}}：</span>
                <span class="label_content">{{ proInfo.pr_Le || 0 }} x {{ proInfo.pr_Wi || 0 }} x {{ proInfo.pr_Hi || 0 }}(CM)</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$hs('包装规格','Package Size','Especificación del paquete')}}：</span>
                <span class="label_content">{{ proInfo.in_Le || 0 }} x {{ proInfo.in_Wi || 0 }} x {{ proInfo.in_Hi || 0 }}(CM)</span>
              </div>
              <div class="label_items">
                <span class="label">{{$hs('外箱规格','Carton Size','Especificación del cartón exterior') }}：</span>
                <span class="label_content">{{ proInfo.ou_Le || 0 }} x {{ proInfo.ou_Wi || 0 }} x {{ proInfo.ou_Hi || 0 }}(CM)</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$hs('毛重/净重','G.W/N.W','Volumen del cartón exterior')}}：</span>
                <span class="label_content">{{ proInfo.gr_We || 0 }} / {{ proInfo.ne_We || 0 }}(KG)</span>
              </div>
              <div class="label_items">
                <span class="label">{{$hs('体积/材积','CBM/Cuft','CBM')}}：</span>
                <span class="label_content">{{ proInfo.bulk_Feet || 0.00}} /{{ proInfo.bulk_Stere || 0.00 }}</span>
              </div>
            </div>
            <div class="cart-box">
              <el-button
                @click="click(proInfo,'')"
                type="primary"
                class="add-cart"
              >{{ ifAdd(proInfo.co_Nu) ? $hs('移除购物车','Remove from Cart','') : $hs('添加购物车','Add To Cart','') }}</el-button>
              <el-button @click="click(proInfo,'BuyNow')" type="primary" class="add-cart_now">{{$hs('立即购买','Buy Now','Comprar ahora')}}</el-button>
              <div class="add-videoLink" v-if="proInfo.other" @click="tiaozhaun(proInfo)">
                <div>
                  <img src="../../assets/shiping.png" alt style="width: 32px;height: 32px;" />
                </div>
                <div>{{ $hs("视频链接","VIDEO LINK",'Enlace al video') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-list" v-if="productList.length > 0">
        <div class="title">{{$hs('类似产品', 'Similar Product','Otros productos similares')}}</div>
        <div class="pro-list">
          <div class="cell" v-for="(item,index) in productList" :key="index" @click="gotolist">
            <everyProduct :productData="item" @goto="gotoDetail" types="big"></everyProduct>
          </div>
        </div>
        <!-- <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="8"
            layout="prev, pager, next, jumper, total"
            :total="totalRows"
          ></el-pagination>
        </div>-->
      </div>
    </div>
    <login-modal ref="loginModal" @register="register" @forgetpassword="forgetpassword"></login-modal>
    <reset-pass-model ref="resetPassModel" @login="login"></reset-pass-model>
    <register-model ref="registerModel" @login="login"></register-model>
  </div>
</template>
<script>
import { queryPage, getDetail } from '@/api/product'
import { insertProductView, insertAddCart } from '@/api/statistics'
import { deletCartsApi, addCartsApi } from '@/api/cart'
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import picZoom from '@/components/productBox/picZoom.vue'
import everyProduct from '@/components/productBox/everyProduct.vue' //单个产品组件
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapActions, mapGetters } from 'vuex'
import transformMark from '@/utils/water'
export default {
  name: 'proDetail',
  components: {
    picZoom,
    swiper,
    swiperSlide,
    everyProduct,
    loginModal,
    registerModel,
    resetPassModel
  },
  data() {
    return {
      productList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 10,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        ma_Nu: '',
        isAnd: false,
        conditionals: []
      },
      activeImg: '',
      activeIndex: 0,
      proInfo: {},
      swiperOption: {
        slidesPerView: 4,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: false, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, // 修改swiper的父元素时，自动初始化swiper
        imgArr: [],
        preventLinksPropagation: false // 阻止点击事件冒泡
      },
      totalRows: 0,
      totalPage: 0
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),

    ifEnquiry() {
      return coNu => {
        let arr = this.getEnquiry[0].list || []
        return arr.findIndex(item => item.co_Nu === coNu) > -1
      }
    },

    // 已加购还是取消加购
    ifAdd() {
      return coNu => {
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  created() {
    this.initData()
    this.statisticsView()
  },
  mounted() {
    sessionStorage.setItem('detail', true)
  },

  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),
    onEnquiry(proInfo) {
      if (!(Object.keys(this.userInfo).length > 0)) {
        this.$refs.loginModal.open()
        return;
      }
      proInfo._num_ = !proInfo._num_
      this.setEnquiry(proInfo)
    },
    async initData() {
      await getDetail({ co_Nu: this.$route.query.coNu, client_Nu: this.userInfo.client_Nu || '' }).then(res => {
        if (res.success) {
          this.proInfo = res.data
          this.proInfo.imgList.forEach(item => {
            transformMark(item.filePath).then(
              result => {
                item.filePath = result
              }
            )
          })
          const ind = this.getEnquiry[0].list.findIndex(
            it => it.co_Nu === this.proInfo.co_Nu
          )
          if (ind > -1) {
            this.proInfo._num_ = true
          } else {
            this.proInfo._num_ = false
          }
          transformMark(res.data.imgUrl).then(
            result => {
              this.activeImg = result
            }
          )
        }
      })

      this.getSameProduct()
    },
    // 统计访问
    statisticsView() {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || '',
          pr_Na: this.proInfo.pr_Na || '',
          co_Nu: this.proInfo.co_Nu || '',
          fa_No: this.proInfo.fa_No || '',
          ma_Na: this.proInfo.ma_Na || '',
          ma_Nu: this.proInfo.ma_Nu || ''
        }
        insertProductView(obj).then(() => { })
      }
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open()
    },
    // 统计加购
    statisticsAddCart(data) {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || '',
          pr_Na: data.pr_Na || '',
          co_Nu: data.co_Nu || '',
          fa_No: data.fa_No || '',
          ma_Na: data.ma_Na || '',
          ma_Nu: data.ma_Nu || ''
        }
        insertAddCart(obj).then(() => { })
      }
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    // 登录
    login() {
      this.getScrollTop();
      this.$refs.loginModal.open()
    },
    gotolist() {
      this.getScrollTop();
    },
    gotoDetail() {
      this.initData()
    },
    tiaozhaun(product) {
      window.open(product.other, '_blank');
    },
    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    // 分页大小操作
    handleSizeChange(pageSize) {
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = pageSize
      this.getSameProduct()
    },
    // 分页翻页操作
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.getSameProduct()
    },
    handleMsg() {
      let content = this.$hs(
        '我们的工作人员会尽快联系您并为您开通账户高级权限。',
        'Our staff will contact you as soon as possible and open your account with advanced permissions',
        'Nuestro personal se pondrá en contacto con usted lo antes posible y abrirá permisos avanzados de cuenta para usted.'
      );
      this.$alert(content, this.$t('LLH.systemTip'), {
        confirmButtonText: this.$t('LLH.confirm'),
        callback: action => { }
      });
    },
    getSameProduct() {
      const loading = this.$loading({
        lock: true,
        text: this.$hs("加载中...", 'loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParam.cl_Nu = this.proInfo.cl_Nu
      this.queryParam.client_Nu = this.userInfo.client_Nu || ''
      queryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            this.productList = res.data.rows || []
            this.queryParam.isAnd = false
            this.productList = this.productList.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })

            this.productList.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(
                result => {
                  item.imgUrl = result
                }
              )
            })

            this.totalRows = res.data.totalRows
            this.totalPage = res.data.totalPage
          }
        })
        .finally(() => {
          loading.close()
        })
    },
    handleMsg() {
      let content = this.$hs(
        '我们的工作人员会尽快联系您并为您开通账户高级权限。',
        'Our staff will contact you as soon as possible and open your account with advanced permissions',
        'Nuestro personal se pondrá en contacto con usted lo antes posible y abrirá permisos avanzados de cuenta para usted.'
      )
      this.$alert(content, this.$t('LLH.systemTip'), {
        confirmButtonText: this.$t('LLH.confirm'),
        callback: action => { }
      })
    },
    click(proInfo, Buytype) {
      this.getScrollTop();
      if (!this.userInfo.id) {
        this.$refs.loginModal.open()
        return
      }
      if (!this.ifAdd(proInfo.co_Nu)) {
        // 添加商品
        if (this.userInfo) {
          addCartsApi({
            client_Nu: this.userInfo.client_Nu,
            userId: this.userInfo.id,
            co_Nu: proInfo.co_Nu,
            number: 1
          }).then(res => {
            if (res.success) {
              this.addCart({
                client_Nu: this.userInfo.client_Nu,
                userId: this.userInfo.id,
                co_Nu: proInfo.co_Nu,
                fa_No: proInfo.fa_No,
                imgUrl: proInfo.imgUrl,
                in_En: proInfo.in_En,
                number: 1,
                ou_Lo: proInfo.ou_Lo,
                pr_En_Na: proInfo.pr_En_Na,
                pr_Na: proInfo.pr_Na,
                price: proInfo.price,
                bulk_Stere: proInfo.bulk_Stere,
                bulk_Feet: proInfo.bulk_Feet,
                gr_We: proInfo.gr_We,
                ne_We: proInfo.ne_We,
                productRemark: proInfo.productRemark || ''
              })
              this.statisticsAddCart(proInfo)
            }
          })
        }
      } else {
        // 删除商品
        if (this.userInfo) {
          deletCartsApi({
            userId: this.userInfo.id,
            coNus: [proInfo.co_Nu]
          }).then(res => {
            if (res.success) {
              this.deleteCart(proInfo.co_Nu)
            }
          })
        }
      }
      if (Buytype == 'BuyNow') {
        this.$router.push({ path: '/cart' })
      }
    },

    // 图片经过时，设置大图
    hoverImg(data) {
      this.activeImg = data.filePath
    },
    // 图片点击时，设置大图
    setImg(data) {
      this.activeImg = data.filePath
    }
  }
}
</script>
<style lang="scss" scoped>
.big-box {
  padding: 10px 0;
  background-color: #fff;

  .pro-box {
    padding: 20px;
    border-radius: 2px;
    min-height: 480px;
    background-color: #fff;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: #143e52;
      margin: 0 0 20px 0;
    }
    .detail-box {
      display: flex;
    }
    & .img-info {
      width: 536px;
      & .goods-img {
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px #f2f2f2;
        border-radius: 3px;
      }

      .swiper {
        position: relative;
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        height: 65px;

        & .swiper-container {
          width: 86%;
          padding: 0 7%;
          height: 67px;
          position: relative;

          & .swiper-wrapper {
            height: 67px;
            display: flex;
            align-items: center;
          }

          & .swiper-slide {
            width: 20% !important;

            & .item-img {
              margin: 0 5px;
              height: 61px;
              border: solid 1px #f2f2f2;
              padding: 2px;
              display: flex;
              justify-content: center;

              & img {
                width: auto;
                max-width: 100%;
                max-height: 65px;
              }
            }
          }
        }
      }
    }

    & .pro-info {
      flex: 1;
      background-color: #fff;
      padding-left: 30px;
      color: #333;
      min-height: 480px;
      .right-title {
        margin-top: 5px;
        font-size: 20px;
        min-height: 26px;
        max-height: 100px;
        font-weight: 700;
        color: #222222;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .label_box {
        display: flex;
        align-items: center;
        height: 50px;
        flex: 1;
        width: 100%;
        border-bottom: 1px solid #f2f2f2;
        .label_items:nth-child(2n) {
          width: 45%;
        }
      }

      .cart-box {
        margin: 20px 0 0 0;
        display: flex;
      }

      .label_items {
        display: flex;
        align-items: flex-start;
        width: 55%;
      }
      .label_items_right {
        display: flex;
        align-items: center;
      }
      .label_prc {
        color: #999999;
        margin: 20px 0 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .label_No {
        display: inline-block;
        color: #999999;
        margin-top: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 14px;
      }
      .label {
        display: inline-block;
        color: #999999;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .label_content {
        color: #222222;
        width: 170px;
        flex: 1;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 14px;
      }
    }
  }
}

.product-list {
  width: 100%;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #222222;
    margin: 50px 0 20px 0;
  }

  .pro-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .cell {
      width: 224px;
      height: 313px;
      margin-right: 20px;
      margin-bottom: 20px;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    background-color: #fff;
    padding: 10px;
    ::v-deep .active {
      background-color: #e33c0b !important;
    }
  }
}

.add-cart {
  height: 42px;
  background: #ff0000;
  border: 1px solid #ff0000;
  font-size: 16px;
  font-weight: 700;
  border-radius: 3px !important;
}
.add-cart_now {
  height: 42px;
  border: 1px solid #ff0000;
  background: #ffffff;
  font-size: 16px;
  font-weight: 700;
  color: #ff0000;
  border-radius: 3px !important;
}
.add-videoLink {
  width: 170px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #fe7415;
  color: #fe7415;
  font-size: 16px;
  font-weight: 700;
  margin-left: 10px;
  border-radius: 3px;
  cursor: pointer;
  img {
    margin-top: 8px;
    margin-right: 5px;
  }
}
:deep .el-pagination__total {
  margin: 0 20px;
}
</style>